<div class="page">
  <div class="page-head">
    <div>
      <h2>{{ 'purchases.title' | translate }}</h2>
      <p class="page-sub">
        {{ 'purchases.subtitle' | translate }}
      </p>
    </div>
  </div>

  <div class="toolbar">
    <mat-form-field appearance="outline" class="month-picker">
      <mat-label>{{ 'purchases.month' | translate }}</mat-label>
      <mat-select [(ngModel)]="month" (selectionChange)="onFilterChange()">
        <mat-option *ngFor="let m of months" [value]="m.value">{{ monthOptionLabel(m.value) }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-field" *ngIf="groups.length > 1">
      <mat-label>{{ 'purchases.group' | translate }}</mat-label>
      <mat-select [(ngModel)]="groupFilter" (selectionChange)="onFilterChange()">
        <mat-option value="">{{ 'purchases.allGroups' | translate }}</mat-option>
        <mat-option *ngFor="let g of groups" [value]="g.id">{{ g.name }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="search-field">
      <mat-icon matPrefix>search</mat-icon>
      <input matInput [(ngModel)]="search" (ngModelChange)="recompute()" [placeholder]="'purchases.searchPlaceholder' | translate">
      <button mat-icon-button matSuffix *ngIf="search" (click)="search = ''">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <span class="spacer"></span>

    <mat-button-toggle-group [(ngModel)]="view" class="view-toggle">
      <mat-button-toggle value="people">{{ 'purchases.perEmployee' | translate }}</mat-button-toggle>
      <mat-button-toggle value="transactions">{{ 'purchases.allPurchases' | translate }}</mat-button-toggle>
    </mat-button-toggle-group>

    <button mat-stroked-button (click)="exportCsv()" [disabled]="!filteredTransactions.length">
      <mat-icon>download</mat-icon> {{ 'purchases.export' | translate }}
    </button>
  </div>

  <div class="state" *ngIf="loading">{{ 'purchases.loading' | translate }}</div>
  <div class="state error" *ngIf="error">{{ error }}</div>

  <ng-container *ngIf="!loading && !error">
    <div class="stat-grid">
      <div class="stat">
        <div class="stat-label">{{ 'purchases.statPurchases' | translate }}</div>
        <div class="stat-value">{{ totals.count }}</div>
      </div>
      <div class="stat">
        <div class="stat-label">{{ 'purchases.statPaidByEmployees' | translate }}</div>
        <div class="stat-value">kr {{ kr(totals.total) }}</div>
        <div class="stat-foot">{{ 'purchases.statSubsidyFoot' | translate }}</div>
      </div>
      <div class="stat">
        <div class="stat-label">{{ 'purchases.statYourSubsidy' | translate }}</div>
        <div class="stat-value">kr {{ kr(totals.subsidy) }}</div>
        <div class="stat-foot">{{ 'purchases.statExVat' | translate }}</div>
      </div>
    </div>

    <div class="table-wrap" *ngIf="view === 'people'">
      <table class="data">
        <thead>
          <tr>
            <th>{{ 'purchases.colEmployee' | translate }}</th>
            <th>{{ 'purchases.colEmail' | translate }}</th>
            <th class="num">{{ 'purchases.colPurchases' | translate }}</th>
            <th class="num">{{ 'purchases.colEmployeePaid' | translate }}</th>
            <th class="num">{{ 'purchases.colYourSubsidy' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let r of byEmployee">
            <td>{{ r.name }}</td>
            <td>{{ r.email || '—' }}</td>
            <td class="num">{{ r.count }}</td>
            <td class="num">kr {{ kr(r.total) }}</td>
            <td class="num">kr {{ kr(r.subsidy) }}</td>
          </tr>
        </tbody>
      </table>
      <div class="state" *ngIf="!byEmployee.length">{{ 'purchases.empty' | translate }}</div>
    </div>

    <div class="table-wrap" *ngIf="view === 'transactions'">
      <table class="data">
        <thead>
          <tr>
            <th>{{ 'purchases.colDate' | translate }}</th>
            <th>{{ 'purchases.colEmployee' | translate }}</th>
            <th>{{ 'purchases.colProduct' | translate }}</th>
            <th class="num">{{ 'purchases.colEmployeePaid' | translate }}</th>
            <th class="num">{{ 'purchases.colYourSubsidy' | translate }}</th>
            <th>{{ 'purchases.colPayment' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let t of filteredTransactions">
            <td>{{ date(t.unix) }}</td>
            <td>{{ t.employeeName || '—' }}</td>
            <td>{{ t.productName || '—' }}</td>
            <td class="num">kr {{ kr(t.salePriceIncSubsidy || t.price) }}</td>
            <td class="num">kr {{ kr(t.subsidizedExVAT) }}</td>
            <td>{{ t.payType || '—' }}</td>
          </tr>
        </tbody>
      </table>
      <div class="state" *ngIf="!filteredTransactions.length">{{ 'purchases.empty' | translate }}</div>
    </div>
  </ng-container>
</div>
